/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Command_SuggestionsInputs */

const he_command_suggestions = /** @type {(inputs: Command_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הצעות`)
};

const en_command_suggestions = /** @type {(inputs: Command_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestions`)
};

/**
* | output |
* | --- |
* | "Suggestions" |
*
* @param {Command_SuggestionsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const command_suggestions = /** @type {((inputs?: Command_SuggestionsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Command_SuggestionsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_command_suggestions(inputs)
	return en_command_suggestions(inputs)
});